import React, { useState } from 'react';
import '../assets/AllTabsCommon.css';
import '../assets/Reports.css';
import '../assets/Utilities.css';
import DeviceView from './DeviceView';
import AggregatedDeviceView from './AggregatedDeviceView';
import DeviceGroupView from './DeviceGroupView';
import GrafanaReports from './GrafanaReports';
import RealTimeTelemetry from './RealTimeTelemetry';


function Reports({ userInfo, role }) {
    // Sub-tab handling
    const subTabs = [
        { key: "AggregatedDeviceView", label: "Aggregate View" },
        { key: "DeviceGroupView", label: "Device Group View" },
        { key: "DeviceView", label: "Device View" },
        { key: "RealTimeTelemetry", label: "Real-Time Telemetry" },
    ];
    const [activeSubTab, setActiveSubTab] = useState(subTabs[0].key);
    const [pendingDeviceId, setPendingDeviceId] = useState(null);

    const renderSubTabContent = () => {
        switch (activeSubTab) {
            case "DeviceView":
                return (
                    <DeviceView
                        initialDeviceId={pendingDeviceId}
                        onInitialDeviceHandled={() => setPendingDeviceId(null)}
                    />
                );
            case "AggregatedDeviceView":
                return (
                    <AggregatedDeviceView
                        onDeviceClick={(deviceId) => {
                            setPendingDeviceId(deviceId);
                            setActiveSubTab('DeviceView');
                        }}
                    />
                );
            case "DeviceGroupView":
                return <DeviceGroupView />;
            case "GrafanaReports":
                return <GrafanaReports />;
            case "RealTimeTelemetry":
                return <RealTimeTelemetry userInfo={userInfo} role={role} />;
            default:
                return null;
        }
    };

    // Main render
    return (
        <div className="content-tab-container">
            <div className="sub-tabs-container">
                {subTabs.map((tab) => (
                    <div
                        key={tab.key}
                        className={`sub-tab ${activeSubTab === tab.key ? "active" : ""}`}
                        onClick={() => setActiveSubTab(tab.key)}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>
            <div className="sub-tab-content">{renderSubTabContent()}</div>
        </div>
    );
}

export default Reports;
